// src/api/config.ts
// CRA reads REACT_APP_* vars at build time. Restart npm start after changing .env.

const fromEnv = process.env.REACT_APP_CLOUDFRONT_URL;

// optional: warn if missing (we'll still fall back)
if (!fromEnv) {
  // eslint-disable-next-line no-console
  console.warn(
    "[config] REACT_APP_CLOUDFRONT_URL is not set; using default. " +
    "Set it in .env and restart the dev server."
  );
}

// export the base URL, trimming any trailing slash to avoid // in requests
export const CLOUDFRONT_BASE_URL = (fromEnv || "https://d3tlsj4vzxypyj.cloudfront.net").replace(/\/+$/, "");